import { EventEmitter, Injectable, Output } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, JsonpClientBackend } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { User } from '../_models/user';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
 
  
  @Output() terminos: EventEmitter<any> = new EventEmitter();

  aceptar() {
    this.terminos.emit('acepto');
  }

  private userSubject: BehaviorSubject<User>;
  public user: Observable<User>;

  constructor(private router: Router,
    private http: HttpClient) { 
      this.userSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('userBIH')));
        this.user = this.userSubject.asObservable();   
    }

  public get userValue(): User {
      if(this.userSubject != null){
        //tomo el token del usuario, verifico que es valido, si es válido returno el usuario
        //si no lo pongo a null y redireciono a home
        //Pensar en esto, siempre que me conecto, trabajar el psible error del token y redireccionar a home y poner a null el usuario
          return this.userSubject.value;
      }

      return null;
      
  }

  public setUser(user: User){
    this.userSubject.next(user);
  }

  login(email: string, password: string): Observable<any> {
    const data: FormData = new FormData();
    data.append("email", email);
    data.append("password", password);
   
    const postRequest = new HttpRequest('POST', environment.api + 'api/user/login',  data, { 
      reportProgress: true,
    });
    return this.http.request(postRequest);
  }

  logout() { 
      // remove user from local storage and set current user to null
      localStorage.removeItem('userBIH');
      this.userSubject.next(null);
      //this.router.navigate(['home']);
  }
 
  register(agencia: string, email:string, password: string, vendedor:string, direccion: string,
    telefono: string, razonSoc: string, twitter: string, facebook: string, instagram: string, imagen: any): Observable<any> { 
      const data: FormData = new FormData();
      data.append("name", agencia);
      data.append("email", email);
      data.append("password", password);
      data.append("vendedor", vendedor);
      data.append("direccion", direccion);
      data.append("telefono", telefono);
      data.append("facebook", facebook);
      data.append("twitter", twitter);
      data.append("instagram", instagram);
      data.append("razonSoc", razonSoc);
      data.append("imagen", imagen);
   
    const postRequest = new HttpRequest('POST', environment.api + 'api/agency/create',  data, { 
      reportProgress: true,
    });
    return this.http.request(postRequest);
  } 

  forgot(email:string): Observable<any> { 
      const data: FormData = new FormData();
      data.append("email", email);
      data.append("link", environment.front + 'home/reset')
         
    const postRequest = new HttpRequest('POST', environment.api + 'api/user/forgotPassword',  data, { 
      reportProgress: true,
    });
    return this.http.request(postRequest);
  } 

  resetPassword(token:string, password: string): Observable<any> { 
    const data: FormData = new FormData();
    data.append("password", password);
           
    const postRequest = new HttpRequest('POST', environment.api + 'api/user/reset?token='+token,  data, { 
      reportProgress: true,
    }
    );
    return this.http.request(postRequest);
  } 

  changePassword(password: string): Observable<any> { 
    const data: FormData = new FormData();
    data.append("password", password);
           
    const postRequest = new HttpRequest('POST', environment.api + 'api/user/updatePassword',  data, { 
      reportProgress: true,
    }
    );
    return this.http.request(postRequest);
  } 
 
  
}
